<template>
  <v-dialog
      v-model="dialog"
      transition="dialog-bottom-transition"
      fullscreen
      scrollable
  >
    <v-card height="80%" class="cart">
      <v-row class="ma-0" style="max-height: 50px;">
        <v-col cols="1">
          <v-btn small tile icon @click="$emit('close')">
            <v-icon color="primary">
              $chevronDown
            </v-icon>
          </v-btn>
        </v-col>

        <v-col cols="7">
          <p class="text-truncate text-subtitle-1 font-weight-medium ma-0">Minha sacola</p>
        </v-col>

        <v-col cols="4">
          <span class="primary--text font-weight-medium ma-0 clear-cart" v-text="'Esvaziar sacola'" @click="dialogClearCart = true" />
        </v-col>
      </v-row>

      <v-list class="px-5 pt-0">
        <v-list-item>
          <v-list-item-avatar>
            <v-img :src="appLogo"></v-img>
          </v-list-item-avatar>

          <v-list-item-content>
            <v-list-item-title v-text="appName" class="primary--text text-overline" />
            <v-list-item-subtitle @click="$emit('close')">
              <span class="primary--text text-caption mt-1 font-weight-bold">Continuar comprando</span>
            </v-list-item-subtitle>
          </v-list-item-content>

        </v-list-item>
      </v-list>

      <v-card-text class="px-2 mt-1" v-if="products.length">
        <div v-for="(product, index) in products" :key="product.ref">
          <v-row class="ma-0 my-2 row-product">
            <v-col cols="2" class="pr-0">
              <v-img
                  v-if="configs.show_image"
                  height="50"
                  width="50"
                  class="mx-auto rounded-lg"
                  :src="product.image"
              />
            </v-col>
            <v-col cols="10" class="pb-0">
              <p class="font-weight-medium primary--text mb-1 text-truncate" @click="edit(product)">
                <v-btn color="primary" icon tile x-small>
                  <v-icon>$pencil</v-icon>
                </v-btn>
                {{product.name}}
              </p>
              <div v-for="attribute in product.attributes" :key="attribute.id">
                <p v-for="option in optionsGrouped(attribute)" class="pl-2 option-name">
                  <span class="d-inline-block">{{option.length}}x</span> {{option[0].name}}
                </p>
              </div>

              <div v-for="additional in additionalsGrouped(product.additionals)" :key="additional.id">
                <p class="pl-2 option-name">
                  <span class="d-inline-block">{{additional.length}}x</span> {{additional[0].name}}
                </p>
              </div>

              <div v-if="product.removedComponents.length" class="mt-2">
                <p class="pl-2 option-name observation"
                   v-text="`Componentes removidos:`" />

                <v-chip
                    class="ml-2 mt-2"
                    x-small
                    color="red"
                    text-color="white"
                    v-for="removedComponent in product.removedComponents"
                    :key="removedComponent.id"
                >
                  {{ removedComponent.name }}
                </v-chip>
              </div>

              <div v-if="product.observation.length" class="mt-2">
                <p class="pl-2 option-name observation"
                   v-text="`Observações:`" />

                <p class="pl-2 option-name observation mt-2"
                   v-for="observation in product.observation"
                   v-text="observation" />
              </div>
            </v-col>

            <v-col cols="7" offset="2" class="py-0">
              <p class="text-subtitle-2 font-weight-bold ma-0 mt-2 pl-2 primary--text">
                {{ formatMoney(product.total_value) }}
                <span class="font-small">{{ product.amount > 1 ? ` (${formatMoney(product.unitary_value)} x ${product.amount})` : ''}}</span>

                <v-tooltip bottom v-if="!product.flg_charge_service_fee">
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon
                        color="primary"
                        dark
                        x-small
                        v-bind="attrs"
                        v-on="on"
                    >
                      $informationOutline
                    </v-icon>
                  </template>
                  <span>Isento de Tx. de Serviço</span>
                </v-tooltip>
              </p>

            </v-col>

            <v-col cols="3" class="pa-0 text-right mt-2" align-self="center">
              <v-btn
                  color="primary"
                  icon
                  tile
                  x-small
                  @click="minus(product)"
                  v-if="product.amount > 1"
              >
                <v-icon>$minus</v-icon>
              </v-btn>
              <v-btn
                  color="red"
                  icon
                  tile
                  x-small
                  @click="deleteProduct = true; productToDelete = product"
                  v-else
              >
                <v-icon>$trashCan</v-icon>
              </v-btn>

              <span class="mx-1" v-text="product.amount"></span>
              <v-btn
                  color="primary"
                  icon
                  tile
                  x-small
                  @click="plus(product)"
              ><v-icon>$plus</v-icon>
              </v-btn>
            </v-col>
          </v-row>

          <p class="error--text mt-1 text-caption mb-2" v-if="errors[product.id]">{{ errors[product.id] }}</p>
          <v-divider></v-divider>
        </div>

        <div class="primary--text px-2 mt-3">
          <p class="font-weight-bold text-body-1 ma-0">Resumo dos itens</p>

          <v-list class="transparent pa-0">
            <v-list-item dense class="primary--text">
              <v-list-item-title>Quantidade</v-list-item-title>
              <v-list-item-subtitle class="text-right font-weight-bold">{{totalProducts}} itens</v-list-item-subtitle>
            </v-list-item>

            <v-list-item dense class="primary--text">
              <v-list-item-title>Sub total</v-list-item-title>
              <v-list-item-subtitle class="text-right font-weight-bold">{{formatMoney(subTotal)}}</v-list-item-subtitle>
            </v-list-item>

            <v-list-item dense class="primary--text" v-if="enableServiceTax">
              <v-list-item-title>Taxa de Serviço</v-list-item-title>
              <v-list-item-subtitle class="text-right font-weight-bold" v-text="`${formatMoney(totalTax)} (${formatPercent(configs.percent_tax)})`" />
            </v-list-item>

            <v-list-item dense class="primary--text">
              <v-list-item-title>Total</v-list-item-title>
              <v-list-item-subtitle class="text-right font-weight-bold">{{formatMoney(total)}}</v-list-item-subtitle>
            </v-list-item>
          </v-list>
        </div>
      </v-card-text>

      <v-card-text v-else>
        <p class="text-subtitle-2 primary--text">Sua sacola está vazia</p>
      </v-card-text>

      <div class="text-center pa-3">
        <v-alert
            v-model="snackbar"
            color="red"
            dark
            dismissible
        >{{textSnackbar}}</v-alert>

        <v-btn color="primary"
               :loading="sending"
               x-large block
               @click="confirmationRequest = true">Enviar Pedido</v-btn>
      </div>
    </v-card>

    <info-product @close="productSelected = null; editProduct = false"
                  :dialog="editProduct"
                  :product="productSelected"
                  :cart-product="cartProduct"
                  editing />

    <dialog-clear-cart :dialog="dialogClearCart"
                       @close="dialogClearCart = false"
                       @confirm="clearCart"/>

    <dialog-delete-product-cart @close="deleteProduct = false"
                                @confirm="minus(productToDelete)"
                                :dialog="deleteProduct"
                                :product="productToDelete ? productToDelete.name : ''"/>

    <dialog-confirmation-request
        :dialog="confirmationRequest"
        @close="confirmationRequest = false"
        @confirm="processSendRequest($event); confirmationRequest = false"/>

    <dialog-sending-request :dialog="sending" :steps-request="stepsRequest" />

    <dialog-show-message :dialog="dialogShowMessage"
                         @close="dialogShowMessage = false; sendRequestData = null"
                         @confirm="sendRequest(sendRequestData); dialogShowMessage = false"
    />
  </v-dialog>
</template>

<script>
import _ from "lodash"
import axios from "axios";
import {initializeApp} from "@firebase/app";
import {getDatabase, onValue, ref, remove} from "@firebase/database";
import { useGlobalCart, useGlobalRequests } from '../../../store/store'
import InfoProduct from "../DigitalMenu/InfoProduct";
import DialogClearCart from "./DialogClearCart";
import DialogDeleteProductCart from "./DialogDeleteProductCart";
import DialogConfirmationRequest from "./DialogConfirmationRequest";
import DialogSendingRequest from "./DialogSendingRequest";
import DialogShowMessage from "./DialogShowMessage.vue";

export default {
  name: "Cart",
  props: {
    dialog: {
      required: true,
      default: false
    },
    configs: {
      required: true
    }
  },
  components: {
    DialogShowMessage,
    InfoProduct,
    DialogClearCart,
    DialogDeleteProductCart,
    DialogConfirmationRequest,
    DialogSendingRequest
  },
  data: () => ({
    products: [],
    errors: [],
    deleteProduct: false,
    editProduct: false,
    productSelected: null,
    cartProduct: null,
    dialogShowMessage: false,
    productToDelete: null,
    dialogClearCart: false,
    sending: false,
    confirmationRequest: false,
    snackbar: false,
    textSnackbar: '',
    sendRequestData: null,
    stepsRequest: [
      {
        text: 'Preparando para envio',
        step: 1,
        success: false,
        processing: true,
      },
      {
        text: 'Pedido enviado',
        step: 2,
        success: false,
        processing: false,
      },
      {
        text: 'Aguardando confirmação',
        step: 3,
        success: false,
        processing: false,
      },
      {
        text: 'Pedido confirmado, em breve será entregue.',
        step: 4,
        success: false,
        processing: false,
      }
    ]
  }),
  mounted() {
    this.init()
  },
  setup() {
    const cart = useGlobalCart()
    const requests = useGlobalRequests()

    return { cart, requests }
  },
  methods: {
    init() {
      this.products = [...this.cart.products, ...this.cart.combos]
      this.calculateTotalPrice()
    },
    optionsGrouped (attributes) {
      return _.groupBy(attributes.options, 'id')
    },
    additionalsGrouped (additionals) {
      return _.groupBy(additionals, 'id')
    },
    edit (product) {
      this.productSelected = product.product
      this.cartProduct = product
      this.editProduct = true
    },
    minus (product) {
      product.amount -= 1
      product.total_value = this.formatValue(product.unitary_value * product.amount)

      let type = this.isCombo(product) ? 'combos' : 'products'

      if (product.amount === 0) {
        let index = this.cart[type].findIndex(item => item.ref === product.ref)

        this.cart[type].splice(index, 1)
        this.deleteProduct = false
        this.productToDelete = null

        this.products.splice(this.products.findIndex(item => item.ref === product.ref), 1)
      }

      this.calculateTaxProduct(product)
      this.calculateTotalPrice()
    },
    plus (product) {
      product.amount += 1
      product.total_value = this.formatValue(product.unitary_value * product.amount)

      this.calculateTaxProduct(product)
      this.calculateTotalPrice()
    },
    calculateTaxProduct (product) {
      if (this.enableServiceTax && product.flg_charge_service_fee) {
        product.tax_value = this.formatValue(product.total_value * (this.configs.percent_tax / 100))
      }
    },
    calculateTotalPrice () {
      if (this.enableServiceTax) {
        this.cart.tax_value = this.formatValue(this.totalTax)
      }

      this.cart.total_value = this.formatValue(this.total)

      if(this.totalProducts === 0) {
        this.$emit('close')
      }
    },
    isCombo (product) {
      return product.composition_type === 1
    },
    clearCart (close = true) {
      this.products = []
      this.cart.products = []
      this.cart.combos = []
      this.cart.sale_start = null
      this.cart.unique_id = null
      this.cart.total_value = 0
      this.cart.tax_value = 0
      this.cart.table_unique_id = null

      if (!!close) {
        this.dialogClearCart = false
        this.resetProcess()
        this.$emit('close')
      }
    },

    async processSendRequest(data) {
      if (this.configs.show_request_confirmation) {
        this.sendRequestData = data
        this.dialogShowMessage = true
      } else {
        await this.sendRequest(data)
      }
    },

    async sendRequest(data) {
      this.errors = []

      this.cart.order_needs_customer_service_opened = this.configs.order_needs_customer_service_opened ?? false;
      this.cart.document = data.document
      this.cart.isCpf = data.isCpf
      this.cart.customer_service_code = this.configs.require_customer_service ? data.customer_service_code : data.document.replace(/\D/g, "");

      if (data.table_number) {
        this.cart.customer_service_code += ' - ' + data.table_number
      }

      if (this.configs.require_table) {
        this.cart.table_unique_id = new URLSearchParams(window.location.search).get('t');
      }

      this.sending = true

      this.processStepRequest(1)

      axios.post(this.route('smartmenu.send-request', _hash), this.cart).then(async response => {
        this.processStepRequest(2)
        const uniqueId = this.cart.unique_id

        // Armazena a chave do pedido
        this.requests.requests.push({
          cart: structuredClone(this.cart),
          status: {status: 2, error: false, message: 'Aguardando confirmação'},
          valid_until: (new Date()).setHours(new Date().getHours() + 3),
          appLogo: this.cart.appLogo,
          appName: this.cart.appName
        });

        this.clearCart(false)

        await this.getRequestStatus(uniqueId).then(async response => {
          let request = this.requests.requests.find(request => request.cart.unique_id === uniqueId)

          if (!response.error) {
            this.processStepRequest(3)

            // Se chegar alguma resposta do PDV, atualize o request com o status recebido
            request.status = {...response, status: 1}

            setTimeout(_ => {
              this.processStepRequest(4)
              this.clearCart()
              this.sending = false
            }, 2000)
          } else {
            request.status = {...response, status: 0}
            this.resetProcess()

            //Redirecionar para tela de pedidos com a mensagem de erro
            this.sending = false
            this.$emit('close')
            this.$emit('openRequests', response.message)
          }

          await this.removeObjectFirebase(uniqueId)
        })
      }).catch(error => {
        //Erro de validação, no momento apenas validação de disponibilidade
        if (error.response.status === 422) {
          Object.entries(error.response.data).forEach((error, a) => {
            this.errors[error[0]] = error[1][0]
          })
        }

        this.sending = false
      })
    },
    dbFirebase (uniqueId = null) {
      const firebaseConfig = _config.firebase_web_credentials

      const app = initializeApp(firebaseConfig)
      const database = getDatabase(app)
      const path =  [_config.firebase_status_path, uniqueId].filter(Boolean).join('/')

      return ref(database, path);
    },

    getRequestStatus (uniqueId) {
      let dbRef = this.dbFirebase(uniqueId)

      return new Promise((resolve, reject) => {
        onValue(dbRef, async snapshot => {
          const data = snapshot.val();
          if (data) {
            resolve(data)
          }

          setTimeout(_ => {
            resolve({error: true, status: 0, message: 'Pedido não confirmado, entre em contato com o estabelecimento.'})
          }, 60000)
        });
      })
    },

    async removeObjectFirebase (uniqueId) {
      let dbRef = this.dbFirebase(uniqueId)
      await remove(dbRef).then(_ => {
        return true
      }).catch(_ => {
        return false
      })
    },

    processStepRequest (step) {
      Object.assign(this.stepsRequest.find(stepR => stepR.step === step), {success: true, processing: false})
      let processing = this.stepsRequest.find(stepR => stepR.step === step + 1)

      if (processing) {
        processing.processing = true
      }
    },
    resetProcess () {
      this.stepsRequest.forEach((step, index) => {
        step.success = false
        step.processing = index === 0;
      })
    },

    safetyCart () {
      const safetyCart = structuredClone(this.cart)
      delete safetyCart['document']
      delete safetyCart['customer_service_code']

      return safetyCart
    }
  },
  computed: {
    subTotal () {
      return _.sumBy(this.cart.products, 'total_value') + _.sumBy(this.cart.combos, 'total_value')
    },
    total () {
      return this.subTotal + this.cart.tax_value
    },
    totalProducts () {
      return _.sumBy(this.cart.products, 'amount') + _.sumBy(this.cart.combos, 'amount')
    },
    enableServiceTax () {
      return this.configs.enable_service_tax && this.configs.percent_tax > 0
    },
    totalTax () {
      return _.sumBy(this.cart.products, 'tax_value') + _.sumBy(this.cart.combos, 'tax_value')
    },
    appName () {
      return _theme.appName
    },
    appLogo () {
      return _theme.logo
    }
  },
  watch: {
    'dialog' (newV) {
      if (newV) {
        this.init()
      }
    }
  }
}
</script>

<style lang="scss">
  .cart {
    .clear-cart {
      font-size: 0.8em
    }
    .option-name {
      font-size: 0.8em;
      margin-bottom: -7px !important;

      &.observation {
        line-height: normal;
      }

      span {
        width: 21px;
      }
    }

    .row-product:last-of-type {
      margin-bottom: 20px !important;
    }

    .v-list-item {
      min-height: 25px;
      padding: 0;
    }
  }

  .font-small {
    font-size: 11px !important;
  }
</style>